import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@criteria-labs/react';
export function ExecuteButton({ onExecute, onCancel, disabled, executing = false }) {
    if (executing) {
        return (_jsx(Button, { className: "w-24", disabled: disabled, onClick: onCancel, children: "Cancel" }));
    }
    else {
        return (_jsx(Button, { color: "indigo", className: "w-24", disabled: disabled, onClick: onExecute, children: "Send" }));
    }
}
